import { getAuthAxios } from "@artprov/design-system";

const pathsSolicitud = {
  getAll: "rendicion",
  getById: "rendicion/:id",
  create: "rendicion",
  update: "rendicion/:id",
  atachmentFile: "rendicion/detalle/file",
  getAtachmentFile: "/rendicion/detalle/file/",
  getAutorizaciones: "/rendicion/autorizar",
  postValidarRecibo: "/rendicion/detalle/verificar",
  postValidarReciboContraArca: "/rendicion/detalle/verificarComprobante"
};

export const getSolicitudes = async () => {
  try {
    const response = await getAuthAxios("default").get(pathsSolicitud.getAll);
    return response;
  } catch (error) {
    console.error("Error getting solicitudes:", error);
    // TODO: Agregar HandlerError y Sentry.
    throw error;
  }
};

/*
Example post request
*/
export const createSolicitud = async (data) => {
  let comprobantes = [];
  data.comprobantes.forEach((elemento, indice) => {
    let comprobante;
    comprobante = {
      tipocomprobanteid: elemento.idTipoComprobante,
      conceptogastoid: elemento.idConceptoDelGasto,
      cae: elemento.caeCai,
      tipoautorizacionafipid: elemento.tipoCaeCai,
      establecimiento: elemento.puntoVenta,
      numero: elemento.numeroFactura?.split('-')[1],
      razonsocial: elemento.razonSocial,
      cuit: elemento.cuit,
      fecha: elemento.fecha,
      importe: elemento.importe,
      idfiles3: elemento.idfiles3 ?? null,
      motivogasto: elemento.motivoGasto,
    };
    comprobantes.push(comprobante);
  });

  let solicitud = {
    idtiposolicitud: data.cabecera.idTipoSolicitud,
    idestado: 1, // estado inicial, no deberia ser necesario enviar
    comprobantes: comprobantes,
  };

  const response = await getAuthAxios("default").post(pathsSolicitud.create, solicitud, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const sendAtachmentDetalleSolicitud = async (data) => {
  let atachment = {
    "id_comprobante": null,
    "file": {
      "name": data?.fileName,
      "size": data?.fileSize,
      "content": data?.fileContent
    }
  }

  const response = await getAuthAxios("default").post(pathsSolicitud.atachmentFile, atachment, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.data;
};

export const getAtachmentDetalleSolicitud = async (id) => {
  const response = await getAuthAxios("default").get(pathsSolicitud.getAtachmentFile + id, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.data;
};

export const getAutorizaciones = async (grupo) => {
  const response = await getAuthAxios("default").get(pathsSolicitud.getAutorizaciones, {
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      grupo: grupo
    }
  })

  return response.data
}

export const postValidarRecibo = async ({ cuit, establecimiento, numero ,tipocomprobanteid}) => {
  const response = await getAuthAxios("default").post(pathsSolicitud.postValidarRecibo, { cuit, establecimiento, numero, tipocomprobanteid })

  return response.data
}

export const postValidarReciboContraArca = async ({tipocomprobanteid, tipoautorizacionafipid, cuit, establecimiento, numero, fecha, importe, cae}) => {
  const response = await getAuthAxios("default").post(pathsSolicitud.postValidarReciboContraArca, {tipocomprobanteid, tipoautorizacionafipid, cuit, establecimiento, numero, fecha, importe, cae})

  return response.data
}

